import { fetchExtensionSkillSuggestions, SkillSuggestionsResult } from 'lib/extensionMessaging';

export const LINKEDIN_SKILL_TYPEAHEAD_MESSAGE = 'harbor-linkedin-skill-typeahead';

export type LinkedInSkillSuggestionsResult = SkillSuggestionsResult;

export function fetchLinkedInSkillSuggestions(query: string): Promise<LinkedInSkillSuggestionsResult> {
  return fetchExtensionSkillSuggestions(LINKEDIN_SKILL_TYPEAHEAD_MESSAGE, { query });
}
